import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home";
import User from "@/views/User";
import Author from "@/views/Author";
import Dashboard from "@/views/Dashboard";
import Publications from "@/views/Publications";
import OAPublications from "@/views/OAPublications";
import Subscription from "@/views/Subscription";
import Licenses from "@/views/Licenses";
import Login from "@/views/Login";
import licensesStatus from "@/views/licensesStatus";
import userGroup from "@/views/UserGroup";
import organization from "@/views/Organization";
import Individuals from "../views/Individuals.vue";
import collection from "@/views/Collection";
import userCollection from "@/views/UserCollection";
import groupSubscription from "@/views/GroupSubscription";
import groupSubscriptionDetails from "@/views/GroupSubscriptionDetails";
import passphraseHint from "@/views/PassphraseHint";
import ImportOnixPublications from "@/views/import/ImportOnixPublications";
import UserActionLogs from "@/views/UserActionLogs";
import UserRequest from "@/views/UserRequest";
import PurchasePublication from "@/views/Purchase";
import Lending from "@/views/Lending";
import PurchaseOrderCancel from "@/views/PurchaseOrderCancel";
import ExternalLinks from "@/views/ExternalLinks";
import Journal from "@/views/Journal";
import JournalCollection from "@/views/JournalCollection";

import OrgDashboard from "@/views/organization/OrgDashboard";
import OrgUsers from "@/views/organization/OrgUsers";
import OrgMyCollections from "@/views/organization/OrgMyCollections";
import OrgGroups from "@/views/organization/OrgGroups";
import OrgPublications from "@/views/organization/OrgPublications";
import OrgMyPublications from "@/views/organization/OrgMyPublications";
import OrgGroupSubscription from "@/views/organization/OrgGroupSubscription";
import OrgCollections from "@/views/organization/OrgCollections";
import OrgLicenses from "@/views/organization/OrgLicenses";
import OrgUserSubscription from "@/views/organization/OrgUserSubscription";
import OrgLogs from "@/views/organization/OrgLogs";
import OrgViewMyPublications from "@/views/organization/OrgViewMyPublications";
import OrgBulkUsers from "@/views/organization/OrgBulkUsers";
import OrgCollectionDetails from "@/views/organization/OrgCollectionDetails";
import OrgJournalCollection from "@/views/organization/OrgJournalCollection";
import OrgViewMyJournals from "@/views/organization/OrgViewMyJournals";

import PubDashboard from "@/views/publisher/PubDashboard";
import PubPublications from "@/views/publisher/PubPublications";
import Purchase from "@/views/Purchase";
import FulfillmentCollections from "@/views/FulfillmentCollections";
import FulfillmentDetails from "@/views/FulfillmentCollectionDetail";
import OrgCollectionNew from "@/views/organization/OrgCollectionNew";
import OrgUserGroups from "@/views/organization/OrgUserGroups";
import OrgOrganizationGroups from "@/views/organization/OrgOrganizationGroups";
import OrgCollectionGroup from "@/views/organization/OrgCollectionGroup/";

import Publisher from "../views/Publisher.vue";
import Institutions from "../views/Institutions.vue";
import AppVersions from "../views/AppVersions.vue";

import LtiPlatform from "./../views/LtiPlatform.vue"
import LtiTokenViewer from "./../views/LtiTokenViewer.vue"
import LtiPublications from "./../views/LtiPublications.vue"
import LtiPublicationView from "../views/LtiPublicationView.vue"
import { name } from "file-loader";

Vue.use(VueRouter);

const routes = [
  { path: "/", name: "dashboard", component: Dashboard },
  { path: "/dashboard", name: "dashboard", component: Dashboard },
  { path: "/user", name: "users", component: User },
  { path: "/author", name: "author", component: Author },
  { path: "/publications", name: "publications", component: Publications },
  {
    path: "/oaPublications",
    name: "oaPublications",
    component: OAPublications,
  },
  { path: "/Subscription", name: "subscription", component: Subscription },
  { path: "/licenses", name: "licenses", component: Licenses },
  { path: "/login", name: "login", component: Login },
  {
    path: "/licensesStatus/:id",
    name: "licensesStatus",
    component: licensesStatus,
  },
  {
    path: "/licensesStatus/license/:id",
    name: "licensesStatus",
    component: licensesStatus,
  },
  { path: "/usergroup", name: "UserGroup", component: userGroup },
  { path: "/organization", name: "Organization", component: organization },
  { path: "/individuals", name: "Individuals", component: Individuals },
  { path: "/publisher", name: "Publisher", component: Publisher },
  { path: "/institutions", name: "Institutions", component: Institutions },
  { path: "/collection", name: "Collection", component: collection },
  { path: "/appversions", name: "AppVersions", component: AppVersions },
  {
    path: "/journal-collection",
    name: "JournalCollection",
    component: JournalCollection,
  },
  {
    path: "/userCollection",
    name: "UserCollection",
    component: userCollection,
  },
  {
    path: "/groupSubscription",
    name: "GroupSubscription",
    component: groupSubscription,
  },
  {
    path: "/groupSubscriptionDetails/:id",
    name: "GroupSubscriptionDetails",
    component: groupSubscriptionDetails,
  },
  {
    path: "/passphraseHint",
    name: "PassphraseHint",
    component: passphraseHint,
  },
  { path: "/import", name: "import", component: ImportOnixPublications },
  { path: "/userlogs", name: "UserActionLogs", component: UserActionLogs },
  { path: "/user-request", name: "UserRequest", component: UserRequest },
  {
    path: "/orgpurchasepublication",
    name: "PurchasePublication",
    component: PurchasePublication,
  },
  { path: "/lending", name: "Lending", component: Lending },
  {
    path: "/purchaseOrderCancel/:id/:organizationId/:isCollection",
    name: "PurchaseOrderCancel",
    component: PurchaseOrderCancel,
  },
  { path: "/ExternalLinks", name: "ExternalLinks", component: ExternalLinks },
  { path: "/Journal", name: "ExternalLiJournalnks", component: Journal },

  {
    path: "/organization/dashboard",
    name: "Dashboard",
    component: OrgDashboard,
  },
  { path: "/organization/users", name: "Users", component: OrgUsers },
  {
    path: "/organization/mycollection",
    name: "OrgMyCollections",
    component: OrgMyCollections,
  },
  {
    path: "/organization/myjournals",
    name: "OrgViewMyJournals",
    component: OrgViewMyJournals,
  },
  { path: "/organization/groups", name: "Groups", component: OrgGroups },
  {
    path: "/organization/publications",
    name: "Publications",
    component: OrgPublications,
  },
  {
    path: "/organization/mypublications",
    name: "MyPublications",
    component: OrgMyPublications,
  },
  {
    path: "/organization/groupSubscription",
    name: "OrgGroupSubscription",
    component: OrgGroupSubscription,
  },
  {
    path: "/organization/collections",
    name: "OrgCollections",
    component: OrgCollections,
  },
  {
    path: "/organization/licenses",
    name: "OrgLicenses",
    component: OrgLicenses,
  },
  {
    path: "/organization/user-subscription",
    name: "OrgUserSubscription",
    component: OrgUserSubscription,
  },
  { path: "/organization/logs", name: "Logs", component: OrgLogs },
  {
    path: "/organization/OrgViewMyPublications",
    name: "OrgViewMyPublications",
    component: OrgViewMyPublications,
  },
  {
    path: "/organization/bulk_users",
    name: "BulkUsers",
    component: OrgBulkUsers,
  },
  { path: "/publisher/dashboard", name: "Dashboard", component: PubDashboard },
  {
    path: "/publisher/publications",
    name: "Publications",
    component: PubPublications,
  },

  {
    path: "/fulfillmentcollections",
    name: "FulfillmentCollections",
    component: FulfillmentCollections,
  },
  {
    path: "/fulfillmentDetails/:id/:collection",
    name: "FulfillmentDetails",
    component: FulfillmentDetails,
  },
  { path: "/purchase", name: "Purchase", component: Purchase },
  {
    path: "/organization/OrgCollectionNew",
    name: "OrgCollectionNew",
    component: OrgCollectionNew,
  },
  {
    path: "/organization/OrgUserGroups",
    name: "OrgUserGroups",
    component: OrgUserGroups,
  },
  {
    path: "/organization/OrgOrganizationGroups",
    name: "OrgOrganizationGroups",
    component: OrgOrganizationGroups,
  },
  {
    path: "/organization/OrgCollectionGroup",
    name: "OrgCollectionGroup",
    component: OrgCollectionGroup,
  },
  {
    path: "/organization/CollectionDetail/:id",
    name: "OrgCollectionDetail",
    component: OrgCollectionDetails,
  },
  {
    path: "/organization/OrgJournalCollection",
    name: "OrgJournalCollection",
    component: OrgJournalCollection,
  },
  {
    path: "/ltiplatform",
    name: "ltiPlatform",
    component: LtiPlatform
  },
  {
    path: "/lti-token-viewer",
    name: "ltiTokenViewer",
    component: LtiTokenViewer
  },
  {
    path: "/lti",
    name: "ltiPublications",
    component: LtiPublications
  },
  {
    path: "/lti/deep-link",
    name: "ltiDeepLink",
    component: LtiPublications
  },
  {
     path: "/lti/publication",
     name: "ltiPublicationView",
     component: LtiPublicationView
  },
];

//localStorage.getItem("token");
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  var token = localStorage.getItem("token");
  console.log("to.name " + to.name);

  if (
    to.name !== "login" &&
    (to.name == "licensesStatus" || to.name == "passphraseHint") &&
    token == null
  ) {
    if (to.name == "licensesStatus" || to.name == "passphraseHint") next();
    else next({ name: "login" });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js